import { DeductionActivity } from "@/core/entities/deduction";
import { useWorkspace } from "@/hooks";
import { Avatar, Division, Flex, Icon, Icons, Card, CardContent, Paragraph, Span } from "@ir/ui";

interface DeductionActivityCardProps {
  activity: DeductionActivity;
}

export const DeductionActivityCard = ({ activity }: DeductionActivityCardProps) => {
  const { logs: deductionActivityLogs, user } = activity;
  const { settings: workspaceSettings } = useWorkspace();

  const logDate = workspaceSettings?.displayDateFormat ? activity.createdOnFormatted(workspaceSettings?.displayDateFormatWithTime) : activity.createdOn;

  return (
    <Card className="activity-card deduction-activity-card">
      <CardContent className="py-2 px-0">
        <Flex justifyContent="space-between" className="mb-1">
          <Flex align="center" gap={0.75}>
            <Avatar
              src={user.avatar ?? undefined}
              name={user.fullName}
              shape="circle"
              size="small"
              isDeleteUser={user.isDeleted}
              title={user.isDeleted ? "Removed User" : (user.fullName ?? "Unassigned")}
            />
            <Flex direction="column">
              <Paragraph className="m-0 font-semibold text-sm text-grey-600">{user.userId == 1 ? "System" : user.fullName}</Paragraph>
              <Span className="text-xs font-normal text-grey-600" style={{ fontSize: "11px" }}>
                {logDate}
              </Span>
            </Flex>
          </Flex>
        </Flex>
        <Flex direction="column" gap={1}>
          {deductionActivityLogs.map((log, index) => (
            <Division key={`${log.message}-${index}`} style={{ marginLeft: "40px" }}>
              {log.message && <Paragraph className="mb-1 text-xs font-normal text-grey-600">{log.message}</Paragraph>}
              {log.fieldData && (
                <Flex direction="column" wrap="wrap">
                  {log.fieldData.map(field => (
                    <Flex key={field.fieldName} wrap="no-wrap">
                      <Span className="m-0 text-xs text-grey-700 pe-1" style={{ minWidth: "130px" }}>{`${field.fieldName}: `}</Span>
                      <Span className="m-0 text-xs font-normal text-grey-600 d-flex flex-align-center" style={{ gap: "0.25rem" }}>
                        <Span>{field.oldValue}</Span>
                        <Span className="flex mx-2" style={{ fontSize: "18px", lineHeight: 1 }}>
                          ➝
                        </Span>
                        <Span>{field.newValue}</Span>
                      </Span>
                    </Flex>
                  ))}
                </Flex>
              )}
              {log.fileList && (
                <Flex direction="column" wrap="wrap">
                  {log.fileList.map(file => (
                    <Flex key={file} align="center">
                      <Icon size="small" className="me-1 text-grey-100" name={Icons.File} />
                      <Paragraph className="m-0 text-xs font-normal text-grey-600">{file}</Paragraph>
                    </Flex>
                  ))}
                </Flex>
              )}
            </Division>
          ))}
        </Flex>
      </CardContent>
    </Card>
  );
};
